import React, { useEffect, useState, useMemo } from "react";
import DataTable from "react-data-table-component";
import Axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { Notyf } from "notyf";
import "notyf/notyf.min.css";
import server from "../../../variables";
import NavbarSA from "../../../components/navbar-sa";
import PrintBillModal from "./printBillModal";
import { jwtDecode } from "jwt-decode";

const BillDashboardUser = () => {
  const notyf = new Notyf();
  const navigate = useNavigate();
  const { consumer: consumerID } = useParams();

  const [bill, setBill] = useState([]);
  const [userData, setUserData] = useState({});
  const [search, setSearch] = useState("");
  const [selectedRowsCSV, setSelectedRowsCSV] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [openPrintBillModal, setOpenPrintBillModal] = useState(false);
  const [billID, setBillID] = useState("");
  const [role, setrole] = useState("");
  console.log(role);

  useEffect(() => {
    document.title = "Dashboard | RBS";
    fetchBill();
  }, []);

  const fetchBill = async () => {
    try {
      const { data } = await Axios.get(
        `${server}user/get-all-bill/${consumerID}`,
        {
          headers: { authorization: localStorage.getItem("token") },
        },
      );

      if (data.status === 410) navigate("/");
      else if (data.status === 200) {
        setBill(data.bill);
        setUserData(data.user);
      } else notyf.error(data.message);
    } catch (err) {
      console.error(err);
      notyf.error("Internal Server Error!");
    }
  };

  const handleSelectedRows = ({ selectedRows }) =>
    setSelectedRowsCSV(selectedRows);

  const filteredBill = useMemo(() => {
    if (!search) return bill;
    const lowerSearch = search.toLowerCase();
    return bill.filter(
      (item) =>
        item.consumerID?.toLowerCase().includes(lowerSearch) ||
        item.billID?.toLowerCase().includes(lowerSearch),
    );
  }, [bill, search]);

  const columns = [
    { name: "Consumer ID", selector: (r) => r.consumerID, sortable: true },
    { name: "Bill ID", selector: (r) => r.billID, sortable: true },
    { name: "Amount", selector: (r) => r.fixedCharges, sortable: true },
    { name: "Bill Month ", selector: (r) => r.month, sortable: true },
    { name: "Bill Year", selector: (r) => r.year, sortable: true },
    {
      name: "Actions",
      center: true,
      cell: (row) => (
        <div className="d-flex gap-2">
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={() =>
              navigate(
                `/dashboard/consumers/${row.consumerID}/bill/${row.billID}`,
              )
            }
          >
            <i className="bi bi-eye-fill"></i>
          </button>
          {role !== "monitoring" && (
            <button
              className="btn btn-outline-warning btn-sm"
              onClick={() => {
                setBillID(row.billID);
                setOpenPrintBillModal(true);
              }}
            >
              <i className="bi bi-printer-fill"></i>
            </button>
          )}
        </div>
      ),
    },
  ];

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        console.log("Decoded token:", decoded);

        if (decoded.scheme) {
          setrole(decoded.role);
        } else {
          console.warn("SchemeID not found in token");
        }
      } catch (error) {
        console.error("Invalid token or decode error", error);
      }
    }
  }, []);

  return (
    <div className="page sa-dashboard">
      {openPrintBillModal && (
        <PrintBillModal
          open={openPrintBillModal}
          handleClose={() => setOpenPrintBillModal(false)}
          billID={billID}
        />
      )}

      <div className="container my-5">
        <div className="card shadow-sm border-0">
          <div className="card-body">
            {/* Header: Search */}
            <div className="d-flex flex-column flex-md-row justify-content-between gap-3 mb-3">
              <div className="input-group shadow-sm search-input">
                <span className="input-group-text bg-white border-0">
                  <i className="bi bi-search text-muted"></i>
                </span>
                <input
                  type="text"
                  className="form-control border-0"
                  placeholder="Search by Bill ID or Consumer ID"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>

            {/* DataTable */}
            <DataTable
              columns={columns}
              data={filteredBill}
              pagination
              paginationPerPage={10}
              highlightOnHover
              striped
              selectableRows
              onSelectedRowsChange={handleSelectedRows}
              clearSelectedRows={toggleCleared}
              fixedHeader
              fixedHeaderScrollHeight="420px"
              responsive
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillDashboardUser;
